import React from 'react';
import styled from '@emotion/styled';
import { Flex, Icon, Text } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

interface PromoPillProps {
  message: string;
  icon?: string;
}

export const StyledPill = styled.div`
  position: absolute;
`;

export const PillBox = styled(Flex)`
  gap: 8px;
  align-items: center;
  color: #323232;
  letter-spacing: 0.5px;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
  background-color: ${themeGet('components.packageOption.pillBackgroundColor')};
  border-radius: 20px 20px 20px 0;
  font-size: 14px;
`;

const Pill = ({ message, icon }: PromoPillProps) => (
  <StyledPill data-testid="PACKAGE_OPTION_PILL">
    <PillBox
      textTransform={'uppercase'}
      padding={['4px 16px', null, '8px 24px']}
    >
      {icon && <Icon name={icon} size={['16px', null, '24px']} />}
      <Text fontSize={['xs', null, 'sm']} textStyle="heading" lineHeight="20px">
        {message}
      </Text>
    </PillBox>
  </StyledPill>
);

export default Pill;
